export default "__VITE_ASSET__CCcOoIs6__"